<template>
  <div class="row pl-3 pb-3 pr-3 pt-1 mr">
    <div :class="getClassResponsive()">
      <div class="regular text-gray">
        Fecha en que se recibe:
      </div>
      <div class="regular">
        {{ formatDate(item.dateReceived) }}
      </div>
    </div>
    <div :class="getClassResponsive()">
      <div class="regular text-gray">
        Fecha en que se atiende:
      </div>
      <div class="regular">
        {{ formatDate(item.dateAttended) }}
      </div>
    </div>
    <div v-if="showAttendeeUser" :class="getClassResponsive()">
      <div class="regular text-gray">
        Persona que atiende:
      </div>
      <div class="regular" v-text="item.personWhoAttends || '-'" />
    </div>

    <slot name="actions" />
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'FacilitatorInquiryItem',
  components: {},
  props: {
    item: { type: Object, default: null },
    isReadOnly: { type: Boolean, default: false },
    showAttendeeUser: { type: Boolean, default: true },
  },
  methods: {
    getClassResponsive() {
      return this.showAttendeeUser
        ? 'col-md-3 col-6 pt-3'
        : 'col-md-4 col-6 pt-3';
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    async save(validate) {
      if (this.isReadOnly) {
        return;
      }
      validate(this.isReadOnly);
    },
  },
};
</script>
